<template>
  <div>
    <Hero />
    <InfoBlocks />
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue'
import InfoBlocks from '@/components/InfoBlocks.vue'

export default {
  name: 'StartPage',
  components: { Hero, InfoBlocks }
}
</script>
